import { render } from "./PermissionCategoryForm.vue?vue&type=template&id=6cac0f40"
import script from "./PermissionCategoryForm.vue?vue&type=script&lang=js"
export * from "./PermissionCategoryForm.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__